<ppl-login-common [value]="credentials$ | async"
                  [mode]="mode"
                  titleEmailScreen="Unlock"
                  i18n-titleEmailScreen="@@Unlock"
                  [loading]="loading$ | async"
                  [error]="errorCode$ | async"
                  [errorMessage]="errorMessage$ | async"
                  [googleShowLogin]="false"
                  [microsoftShowLogin]="false"
                  [showRememberMe]="false"
                  (valueChange)="onSubmit($event)"
                  (edit)="onEdit()"></ppl-login-common>